// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gTJFkmo9SEIUvsYLt0HA{flex-wrap:wrap;justify-content:space-between;gap:24px 12px;padding:30px 4px 40px;display:flex}.gTJFkmo9SEIUvsYLt0HA .q900YYzA0AgHYc7o07xp{flex-direction:column;gap:4px;width:100%;max-width:354px;display:flex}.OoGGUnxZtfIiFnvQ0QBA{flex-direction:column;gap:32px;padding:31px 4px 32px;display:flex}.OoGGUnxZtfIiFnvQ0QBA .FZQK3OsWKekduIvjGBgo{justify-content:space-between;align-items:center;display:flex}.OoGGUnxZtfIiFnvQ0QBA .FZQK3OsWKekduIvjGBgo .uk8SLlbjdrsd5t7q9i3Q{flex-direction:column;gap:4px;display:flex}.BwKJKIxlLsH5MQwFzwRk input[readonly]{pointer-events:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formWrap": `gTJFkmo9SEIUvsYLt0HA`,
	"inputWrap": `q900YYzA0AgHYc7o07xp`,
	"actionsWrap": `OoGGUnxZtfIiFnvQ0QBA`,
	"action": `FZQK3OsWKekduIvjGBgo`,
	"label": `uk8SLlbjdrsd5t7q9i3Q`,
	"phoneWrap": `BwKJKIxlLsH5MQwFzwRk`
};
export default ___CSS_LOADER_EXPORT___;
